if (!customElements.get("custom-reviews-slider")) {
  class customReviewsSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sliderContainer = this.querySelector(
        ".custom-reviews-slider__reviews"
      );
      this.prevButton = this.querySelector(".custom-reviews-slider__nav-button--prev");
      this.nextButton = this.querySelector(".custom-reviews-slider__nav-button--next");
      this.pagination = this.querySelector(".custom-reviews-slider__pagination");
      this.navigation = this.querySelector(".custom-reviews-slider__nav");

      this.initSlider();
    }

    initSlider() {
      if (!this.sliderContainer) return;

      const customerReviewsSlider = new Swiper(this.sliderContainer, {
        slidesPerView: 1,
        spaceBetween: 20,
        autoHeight: true,
        grabCursor: true,
        navigation: {
          nextEl: this.nextButton,
          prevEl: this.prevButton,
        },

        pagination: {
          el: this.pagination,
          clickable: true,
        },

        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },

          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },

          1024: {
            slidesPerView: 3,
            spaceBetween: 44,
          },
        },

        on: {
          init: () => {
            this.updateNavigationVisibility(customerReviewsSlider);
          },
          resize: () => {
            this.updateNavigationVisibility(customerReviewsSlider);
          },
        },
      });
    }

    updateNavigationVisibility(swiper) {
      const slidesPerView = swiper.params.slidesPerView;
      const realSlidesPerView = swiper.params.breakpoints
        ? swiper.slidesPerView
        : slidesPerView;

      if (swiper.slides.length <= realSlidesPerView) {
        this.navigation.style.display = "none";
      } else {
        this.navigation.style.display = "";
      }
    }
  }

  customElements.define("custom-reviews-slider", customReviewsSlider);
}
